import { Component, Input } from '@angular/core';

@Component({
    selector: 'apc-jira-user-creation-success',
    templateUrl: './jira-user-creation-success.component.html',
    styleUrls: ['./jira-user-creation-success.component.scss', '../jira-users.component.scss'],
    standalone: false
})
export class JiraUserCreationSuccessComponent {
  @Input() modalRef: any;
  @Input() data: any = null;

  close() {
    this.modalRef.dismiss();
  }
}
